import Avatar from "./basic-13-avatar.png";
import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import BgOption1 from "./../images/bg-option-1.png";
import BgOption2 from "./../images/bg-option-2.png";
import BgOption3 from "./../images/bg-option-3.png";
import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic13 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #13";
    this.id = "13";
    this.url = "/ai/carousels/basic-13";
    this.description =
      "Create a simple and sleek carousel without the need for your image";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Jon Snow",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@jon-snow",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#734EC2",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#ffffff",
        },
        {
          label: "Secondary Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#32196A",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Manrope",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "How to generate leads on Linkedin for your business",
            max_words: 8,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Sed ut perspiciatis unde omnis iste natus error sit voluptatem.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Optimize your business page",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Use relevant keywords in your headline and description, and include a clear call-to-action (CTA) to encourage visitors to take action.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Share Relevant Content",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Use relevant keywords in your headline and description, and include a clear call-to-action (CTA) to encourage visitors to take action.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Engage with Your Followers",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Engage with your followers by responding to comments and messages, and by participating in relevant Linkedin groups.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "Was this helpful?.",
            max_words: 2,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Ask any questions in the comments. Like, share and save for later.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getSecondaryColor(common_settings) {
    return common_settings.elements[5].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getBackgroundColorVariant(common_settings) {
    return this.getBackgroundColor(common_settings) + "20";
  }

  getBackgroundColorVariantSecond(common_settings) {
    return this.getBackgroundColor(common_settings) + "40";
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[6]?.value || "Manrope";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute top-[48px] left-[40px] inline-flex w-[128px] h-[128px]">
          <img
            className="object-cover w-[128px] h-[128px] rounded-full"
            src={
              commonSettings.elements[1].value.image
                ? commonSettings.elements[1].value.image
                : LogoPlaceholder
            }
            alt=""
          />
        </div>
        <div className="absolute inset-x-0 px-[40px] top-[192px] leading-[60px] flex flex-col gap-[16px]">
          <div
            className="text-[30px] font-bold leading-[38px]"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div
            className="text-[16px] font-medium leading-[24px]"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>
        <div
          className="absolute left-[80px] w-[320px] h-[12px] rounded-l-full top-[348px] z-20"
          style={{
            backgroundColor: this.getSecondaryColor(this.common_settings),
          }}
        />
        <div className="absolute top-[440px] left-[40px]">
          <svg
            width="97"
            height="20"
            viewBox="0 0 97 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 10.2715C19.9397 12.8956 18.89 15.3646 16.7644 17.3557C15.7925 18.2662 14.6695 18.9393 13.4193 19.3929C12.0507 19.8904 10.5899 20.0826 9.1393 19.9559C7.68869 19.8292 6.2833 19.3867 5.02156 18.6595C4.92447 18.6036 4.846 18.6213 4.75437 18.6548C3.57485 19.0849 2.39532 19.5167 1.21407 19.9408C0.863685 20.0665 0.540869 19.9904 0.276656 19.7286C0.00871841 19.463 -0.0672676 19.1375 0.060369 18.7815C0.489467 17.5835 0.923034 16.3871 1.36107 15.1924C1.37514 15.1587 1.38069 15.1221 1.37723 15.0857C1.37376 15.0494 1.36139 15.0144 1.34121 14.984C0.912669 14.2471 0.582648 13.457 0.359595 12.6342C0.0714628 11.591 -0.0428892 10.5074 0.0211344 9.42699C0.151585 7.27478 0.89398 5.36025 2.24832 3.68341C3.33422 2.34179 4.68831 1.35223 6.29222 0.712482C7.66774 0.160784 9.14935 -0.075481 10.6281 0.021055C14.4555 0.256582 17.8163 2.67595 19.2632 6.24166C19.7514 7.44389 19.9898 8.69681 20 10.2715Z"
              fill={this.getSecondaryColor(commonSettings)}
            />
            <path
              d="M55.2253 0.45459C52.1855 0.45459 50.5003 2.62897 50.5003 2.62897C50.5003 2.62897 48.815 0.45459 45.7753 0.45459C42.5854 0.45459 40.0002 3.01598 40.0002 6.17663C40.0002 10.516 45.1579 14.7212 46.5953 16.0498C48.2512 17.5791 50.5003 19.5454 50.5003 19.5454C50.5003 19.5454 52.7494 17.5791 54.4052 16.0498C55.8427 14.7212 61.0003 10.516 61.0003 6.17663C61.0003 3.01598 58.4152 0.45459 55.2253 0.45459Z"
              fill={this.getSecondaryColor(commonSettings)}
            />
            <path
              d="M96.2734 18.4153C96.2734 18.8843 95.7403 19.1543 95.3622 18.8769L88.9757 14.1911C88.7742 14.0433 88.4999 14.0433 88.2984 14.1911L81.9119 18.8769C81.5338 19.1543 81.0007 18.8843 81.0007 18.4153V1.0271C81.0007 0.710912 81.2571 0.45459 81.5732 0.45459H95.7009C96.0171 0.45459 96.2734 0.710912 96.2734 1.0271V18.4153Z"
              fill={this.getSecondaryColor(commonSettings)}
            />
          </svg>
        </div>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div
          className="absolute w-[107px] h-[36px] top-[40px] rounded-r-full flex items-center"
          style={{
            backgroundColor: this.getSecondaryColor(commonSettings),
          }}
        >
          <p
            className="ml-[40px] text-[14px] leading-[20px] font-semibold"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            <TextView text={`Page ${index}`} />
          </p>
        </div>
        <div
          className="absolute w-[24px] h-[36px] top-[40px] left-[376px]"
          style={{
            backgroundColor: this.getSecondaryColor(commonSettings),
          }}
        />
        <div className="absolute inset-x-0 px-[40px] top-[124px] flex flex-col gap-[16px]">
          <div
            className="text-[30px] leading-[38px] font-bold"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div
            className="text-[16px] leading-[24px] font-medium"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute top-[48px] left-[40px] inline-flex w-[128px] h-[128px]">
          <img
            className="object-cover w-[128px] h-[128px] rounded-full"
            src={
              commonSettings.elements[1].value.image
                ? commonSettings.elements[1].value.image
                : LogoPlaceholder
            }
            alt=""
          />
        </div>
        <div className="absolute inset-x-0 px-[40px] top-[192px] leading-[60px] flex flex-col gap-[16px]">
          <div
            className="text-[36px] font-bold leading-[44px]"
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
        </div>
        <div
          className="absolute w-[320px] h-[12px] rounded-r-full top-[348px] z-20"
          style={{
            backgroundColor: this.getSecondaryColor(this.common_settings),
          }}
        />
        <div className="absolute px-[40px] top-[384px] text-[18px] leading-[28px]">
          <div
            style={{
              color: this.getPrimaryColor(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getPrimaryFont(this.common_settings),
        }}
      >
        <div className="absolute inset-0">
          <div
            className="absolute top-[200px] left-[100px] inline-flex w-[300px] h-[300px] z-10"
            style={{
              color: this.getPrimaryColor(this.common_settings),
            }}
          >
            <svg
              width="300"
              height="300"
              viewBox="0 0 300 300"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.1">
                <path
                  d="M258.295 68.795L285.02 137.933L280.372 199.518L231.57 263.428L150.231 287.248L98.5226 280.857L40.4228 235.54L14.8594 189.642V101.912L65.9871 36.2596L143.258 12.439L197.29 20.5726L258.295 68.795ZM258.295 68.795L243.189 125.732L258.295 203.004L231.57 261.684M197.872 20.5726L192.643 55.4321M192.643 55.4321L172.308 119.923L192.643 190.803L197.872 252.389M192.643 55.4321L243.189 125.151L173.47 118.76M197.872 252.389L149.36 286.667M197.872 252.389L126.991 241.93L192.643 190.222L112.466 162.335L171.727 119.341L112.466 78.6714L192.643 56.0124M149.649 286.087L127.572 242.654L111.886 163.316V77.6077L123.505 18.5392L197.001 21.7351M66.5684 36.2596L42.1655 128.056L60.1765 201.842L66.5674 255.874L16.6022 191.966M257.714 68.2138L191.481 54.8508L124.086 18.2486L60.7578 59.4989L15.4397 101.33M60.7578 60.0802L111.304 78.6714L42.7468 126.313L111.304 162.916L60.7578 204.166L126.991 241.35L67.1486 256.165L149.359 286.086M15.4406 101.912L42.1655 127.475L15.4406 189.642L59.5963 203.585M244.351 125.151L283.859 138.514L258.876 203.585L279.211 200.099M243.189 126.314L192.643 188.479L258.296 203.585L197.291 252.389L232.151 263.428"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </svg>
          </div>
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
            ></div>
          )}
        </div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        <div className="absolute inset-x-0 top-[420px] left-[40px]">
          <div
            className="flex gap-[8px]"
            style={{
              color: this.getPrimaryColor(this.common_settings),
            }}
          >
            {index !== 0 && index !== carouselLength - 1 && (
              <>
                <div>
                  <img
                    className="object-cover w-[40px] h-[40px] rounded-full"
                    src={
                      commonSettings.elements[1].value.image
                        ? commonSettings.elements[1].value.image
                        : LogoPlaceholder
                    }
                    alt=""
                  />
                </div>

                <div className="flex flex-col">
                  <p className="font-semibold text-[16px] leading-[24px] whitespace-nowrap">
                    {commonSettings.elements[0].value}
                  </p>
                  <p className="font-normal text-[12px] leading-[18px]">
                    {commonSettings.elements[2].value}
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Basic13;
